import axios from 'axios';
import {
    ERROR_MESSAGE,
    editGuestyTasksUrl,
    getGuestyTasksUrl,
    getPlandayShiftsUrl,
    guestyMasterIntegrationUrl,
} from './constants';

const fetchTasks = async (date) => {
    try {
        const response = await axios.post(
            getGuestyTasksUrl,
            {
                day: date,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(ERROR_MESSAGE, error);
        throw error;
    }
};

const fetchPlandayShifts = async (date) => {
    try {
        const response = await axios.post(
            getPlandayShiftsUrl,
            {
                date: date,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(ERROR_MESSAGE, error);
        throw error;
    }
};

const fetchListings = async () => {
    try {
        const requestData = {
            type: 'GET',
            url: 'listings',
            filters: [
                { operator: '$eq', field: 'active', value: true },
                { operator: '$ne', field: 'listingType', value: 'complex' },
            ],
            fields: 'nickname',
            sort: '',
            limit: '100',
            data: '',
            b_getall: true,
        };

        const response = await axios.post(
            guestyMasterIntegrationUrl,
            requestData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-caller-function': 'housekeeping-management',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(ERROR_MESSAGE, error);
        throw error;
    }
};

const fetchUsers = async () => {
    try {
        const requestData = {
            type: 'GET',
            url: 'users',
            filters: '',
            fields: '_id fullName email emails',
            sort: '',
            limit: '200',
            data: '',
            b_getall: true,
        };

        const response = await axios.post(
            guestyMasterIntegrationUrl,
            requestData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-caller-function': 'housekeeping-management',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(ERROR_MESSAGE, error);
        throw error;
    }
};

const createTask = async (task) => {
    try {
        const taskData = {
            description: task.description,
            plannedDuration: task.duration / 60,
            assigneeId: task.assigneeId,
            title: task.title,
            listingId: task.listingId,
            mustFinishBefore: task.mustFinishBefore
                ? new Date(task.mustFinishBefore).toISOString()
                : null,
            startTime: new Date(task.startTime).toISOString(),
            priority: 'medium',
        };

        const requestData = {
            type: 'POST',
            url: 'tasks-open-api/create-single-task',
            filters: '',
            fields: '',
            sort: '',
            limit: '',
            data: taskData,
            b_getall: true,
        };

        const response = await axios.post(
            guestyMasterIntegrationUrl,
            requestData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-caller-function': 'housekeeping-management',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(ERROR_MESSAGE, error);
        throw error;
    }
};

const editTask = async (task) => {
    try {
        const taskData = {
            description: task.description,
            assigneeId: task.assigneeId,
            title: task.title,
            mustFinishBefore: task.mustFinishBefore
                ? new Date(task.mustFinishBefore).toISOString()
                : null,
            plannedDuration: task.duration / 60,
            startTime: new Date(task.startTime).toISOString(),
        };

        const requestData = {
            type: 'PUT',
            url: 'tasks-open-api/' + task.id,
            filters: '',
            fields: '',
            sort: '',
            limit: '',
            data: taskData,
            b_getall: true,
        };

        const response = await axios.post(
            guestyMasterIntegrationUrl,
            requestData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-caller-function': 'housekeeping-management',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(ERROR_MESSAGE, error);
        throw error;
    }
};

const editTasks = async (tasks = []) => {
    try {
        const response = await axios.post(
            editGuestyTasksUrl,
            { tasks },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(ERROR_MESSAGE, error);
        throw error;
    }
};

export {
    fetchTasks,
    fetchPlandayShifts,
    fetchListings,
    fetchUsers,
    createTask,
    editTask,
    editTasks,
};
